import { Pipe, PipeTransform } from '@angular/core';

/**
 * Appends st, nd, th to number
 *
 * __Usage :__
 *   day | ngxDateNth
 *
 * __Example :__
 *   {{ 27 | ngxDateNth }}
 *   formats to: 27th
 *
 * Module {@link TransformDateNthModule}
 */
@Pipe({
    name: 'ngxDateNth'
})

export class TransformDateNthPipe implements PipeTransform {
    transform(day: number): string {

        if (day > 3 && day < 21) return `${day}th`;
        switch (day % 10) {
            case 1:  return `${day}st`;
            case 2:  return `${day}nd`;
            case 3:  return `${day}rd`;
            default: return `${day}th`;
        }
    }
}
